import React, { useState,useEffect } from 'react'
import { LeftOutlined } from "@ant-design/icons";
import { useQuery, useMutation } from "@apollo/client";
import { Text } from "../../formitems/Index";
import { Qualification,getClientId,qmap1,qmap2,qmap3,clients,Manager,category,subcatagory,Qualification_Query ,Qualification_Add,Qualification_Update,Qualification_Delete} from '../../../Queries/Qualification/Qualification'
import { Switch } from "antd";
import { Menu, Dropdown,InputNumber } from 'antd';
import { Select } from "antd";
import { DownOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import firebase from "../../../Firebase/firebase"
const Qualifications = () => {
  const [search, setsearch] = useState("")
  const [add_new_qualification, setadd_new_qualification] = useState(false)
  const [isEdit, setisEdit] = useState(false)
  const [toggle, settoggle] = useState(true)
  const [val2, setval2] = useState('')
  const [Caption1, setCaption1] = useState('')
  const [Caption2, setCaption2] = useState('')
  const [manager, setmanager] = useState('')
  const [manager2, setmanager2] = useState('')
  const [Caption3, setCaption3] = useState('')
  const [qualification, setqualification] = useState('')
  const [isView, setisView] = useState(false)
  const [currentFormData, setCurrentFormData] = useState({})
  const [validity, setvalidity] = useState(0)
  const [dropdown, setdropdown] = useState('')
  const [dropdown2, setdropdown2] = useState('')
  const [cost, setcost] = useState(0)
  const [users, setusers] = useState({})
  useEffect(() => {
      firebase.auth().onAuthStateChanged(async user => {
          if (user) {
              const token = await user.getIdToken();
              const idTokenResult = await user.getIdTokenResult();
              setusers({
                  user: user,
                  token: idTokenResult,
                  jwt: token
              })
          }
          else console.log("SIGNED OUT");
      })
  }, [])
  const { data: getclient } = useQuery(getClientId, {
    variables: { id: users?.token?.claims?.user_id }
})
  const { data } = useQuery(Qualification,{
    variables: { active: toggle }
  })
  const { data: datas } = useQuery(category)
  const { data: dat } = useQuery(subcatagory)
  const { data: dataa } = useQuery(clients)
  const { data: dataaa } = useQuery(Manager, {
    variables:{ id: dropdown2[1]}
  })
  
  const [insertQualification, { data: da }] = useMutation(Qualification_Add, {
    refetchQueries: [{ query: Qualification, variables:{active: true}},{ query: Qualification, variables:{active: false}}]
  })
  console.log(da)
  const [insqmap, { data: qm }] = useMutation(qmap1)
  const [insqmap2, { data: qm2 }] = useMutation(qmap2)
  const [insqmap3, { data: qm3 }] = useMutation(qmap3)

  useEffect(() => {
    const add_qualificationn = (i) => {
      if (i !== undefined) {
        insqmap({
          variables: { id: i, clientsid: getclient?.aatmsv4_users[0]?.client.clientsid, email: getclient?.aatmsv4_users[0]?.email,managersid1: dropdown[1],qcode: val2} 
        })
      }
      if (i !== undefined && manager2[1] !== dropdown[1] && manager2[1] !== manager[1] ) {
        insqmap2({
          variables: { id: i, clientsid: getclient?.aatmsv4_users[0]?.client.clientsid, email: getclient?.aatmsv4_users[0]?.email,managersid1: manager[1],qcode: val2}
        })
      }
      if (i !== undefined && manager[1] !== dropdown[1] && manager[1] !== manager2[1] ) {
        insqmap3({
          variables: { id: i, clientsid: getclient?.aatmsv4_users[0]?.client.clientsid, email: getclient?.aatmsv4_users[0]?.email,managersid1: manager2[1],qcode: val2}
        })
      }
    }
    if (da !== undefined) {
      add_qualificationn(da?.insert_aatmsv4_qualifications?.returning[0]?.qid)
    }
  }, [da])
  const [UpdateQualication, { data: datt }] = useMutation(Qualification_Update, {
    refetchQueries: [{ query: Qualification, variables:{active: true} },{ query: Qualification, variables:{active: false} }]
  })
  const togle = () => {
    toggle ? settoggle(false) : settoggle(true)
  }
  const add_new_qualifications = () => {
    setadd_new_qualification(true)
  };
  const editfleet = () => {
    setisEdit(true)
  }
  const View = () => {
    setisView(true)
  }
  const closeForm = () => {
    setadd_new_qualification(false)
    setisEdit(false)
    setisView(false)
  };
  const menu = (data) => (
    <Menu>
      <Menu.Item>
        <Link onClick={() => {
          setCurrentFormData(data)
          editfleet()
        }}>Edit</Link>
      </Menu.Item>
      <Menu.Item>
        <Link onClick={() => {
          setCurrentFormData(data)
          View()
        }}>View</Link>
      </Menu.Item>
    </Menu>)
  const handleFormFields = (v, fieldName) => {
    switch (fieldName) {
      case "qualification":
        setCurrentFormData({ ...currentFormData, qualification: v })
        break;
      case "caption1":
        setCurrentFormData({ ...currentFormData, caption1: v })
        break;
        case "caption2":
        setCurrentFormData({ ...currentFormData, caption2: v })
        break;
        case "caption3":
        setCurrentFormData({ ...currentFormData, caption3: v })
        break;
        case "cost":
        setCurrentFormData({ ...currentFormData, cost: v })
        break;
        case "qcode":
        setCurrentFormData({ ...currentFormData, qcode: v })
        break;
        case "validity":
        setCurrentFormData({ ...currentFormData, validity: v })
        break;
        case "true":
        setCurrentFormData({ ...currentFormData, active: v })
        break;
        case "clientname":
        setCurrentFormData({ ...currentFormData, clientnamee: v })
        break;
        case "managername":
        setCurrentFormData({ ...currentFormData, managername: v })
        break;
      default:
        break;
    }
  }
  function onChange(value) {
    setvalidity(value)
  }
  const Option = Select.Option;
  const emptystate = () => {
    setdropdown2('')
    setdropdown('')
    setval2('')
    setqualification('')
    setCaption1('')
    setCaption2('')
    setCaption3('')
    setcost(0)
    setvalidity(0)
  }
  return (
    <div className="animate__animated animate__fadeIn">
      <div className={add_new_qualification || isEdit  || isView ? "hide-element" : ""}>
        <div className="category-title">Qualifications</div>
        <button className="submit-button" onClick={() => {
          add_new_qualifications()
          emptystate()
        }}>
          Add New Qualifications
      </button>
        <div className="table-body-container">
          <div className="table-body-header">All Qualifications</div>
          <div className="client-list-divider"></div>
          <div className="table-container">
            <div className="table-header-container">
              <div className="display-record">
                <span>records 10</span>
              </div>
              <div className="active-switch">
                <span>Active</span>
                <Switch onClick={togle} defaultChecked />
              </div>
              <div className="search-bar">
                <span>Search</span>
                <input type="text" value={search} onChange={(e) => setsearch(e.target.value)} />
              </div>
            </div>
            {data?.aatmsv4_qualifications?.map((data, index) => {
              if (data.clientname.toLowerCase().includes(search.toLowerCase())) {
                return (
                  <div className="table-row-container" key={index}>
                    <div className="table-row-top">
                      <div className="items">
                        <div className="title">Client</div>
                        <div className="value">{data.clientname}</div>
                      </div>
                      <div className="items">
                        <div className="title">Q. Code</div>
                        <div className="value">{data.qcode}</div>
                      </div>
                      <div className="items">
                        <div className="title">Qualification</div>
                        <div className="value">{data.qualification}</div>
                      </div>
                      <div className="items">
                        <div className="title">Data 1</div>
                        <div className="value">{data.caption1}</div>
                      </div>
                      <div className="items">
                        <div className="title">Data 2</div>
                        <div className="value">{data.caption2}</div>
                      </div>
                      <div className="items">
                        <div className="title">Data 3</div>
                        <div className="value">{data.caption3}</div>
                      </div>
                      <Dropdown overlay={menu(data)}>
                        <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                          <i className="fa fa-ellipsis-h" />
                          <DownOutlined />
                        </a>
                      </Dropdown>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
        <div className="print-email-container">
          <button className="print-button">
            <i className="fa fa-print" />
          Print
        </button>
          <button className="email-button">
            <i className="fa fa-envelope" />
          Email
        </button>
        </div>
      </div>
      <div className={add_new_qualification ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} QUALIFICATIONS
        </span>
        Add New Qualification
      </div>
        <div className="toggle-form-container">
          <span>Client</span>
          <Select value={dropdown2 ? dropdown2 : 'Select Clients'} onChange={e => setdropdown2(e)}>
              {dataa?.aatmsv4_clients?.map((el, i) => (
                <Option key={i} value={[el.clientname,el.clientsid]}>{el.clientname}</Option>
              ))}
            </Select>
            <span>Manager</span>
            <Select value={dropdown ? dropdown : "Select Manager"}  onChange={e => setdropdown(e)}>
              {dataaa?.aatmsv4_managers?.map((el, i) => (
                <Option key={i} value={[el.managername,el.managersid]}>{el.managername}</Option>
              ))}
          </Select>
          <span>Manager2</span>
            <Select value={manager ? manager : "Select Manager 2"}  onChange={e => setmanager(e)}>
              {dataaa?.aatmsv4_managers?.map((el, i) => (
                <Option key={i} value={[el.managername,el.managersid]}>{el.managername}</Option>
              ))}
          </Select>
          <span>Manager3</span>
            <Select value={manager2 ? manager2 : "Select Manager 3"}  onChange={e => setmanager2(e)}>
              {dataaa?.aatmsv4_managers?.map((el, i) => (
                <Option key={i} value={[el.managername,el.managersid]}>{el.managername}</Option>
              ))}
          </Select>
          <Text title="Catagory" value="Certificate" disabled />
          <Text title="Q. Code" value={val2} onChange={(e) => setval2(e.target.value)} />
          <Text title="Qualification Name" value={qualification} onChange={(e) => setqualification(e.target.value)} />
          <Text title="Caption1" value={Caption1} onChange={(e) => setCaption1(e.target.value)} />
          <Text title="Caption2" value={Caption2} onChange={(e) => setCaption2(e.target.value)} />
          <Text title="Caption3" value={Caption3} onChange={(e) => setCaption3(e.target.value)} />
          <Text title="Cost" value={cost} onChange={(e) => setcost(e.target.value)} />
          <span>Validity</span><br />
          <InputNumber title="Validity" placeholder="Select validity 1 to 100" min={1} max={100} defaultValue={1} onChange={onChange} />
          <br />
          <button className="submit-button" onClick={()=> {
            insertQualification({ variables: {manager2: manager[1],manager3: manager2[1],Validy:validity,Cost:cost,managerId:dropdown[1],managerName:dropdown[0],clientid: dropdown2[1],clientname:dropdown2[0],qCode:val2,QualificationName:qualification,caption1:Caption1,caption2:Caption2,caption3:Caption3 } })
            closeForm()
          } }>Add</button>
          <button onClick={() => {
            closeForm()
            emptystate()
          } } className="cancel-button">
            Cancel
        </button>
        </div>
      </div>
{/* Edit Quialification  */}

      <div className={isEdit ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Qualification
            </span>
            Edit Qualification
          </div>
        <div className="toggle-form-container">
          <div className="input-box-container">
            <div className="input-box-title">
            </div>
          <Text title="Client" disabled value={currentFormData.clientname} onChange={(e) => handleFormFields(e.target.value,'clientname')} />
          <Text title="Manager" disabled value={currentFormData?.manager?.managername} onChange={(e) => handleFormFields(e.target.value,'managername')} />
          </div>
          <div className="input-box-container">
          <Text title="Q. Code" value={currentFormData.qcode} onChange={(e) => handleFormFields(e.target.value,'qcode')} />
          <Text title="Qualification Name" value={currentFormData.qualification} onChange={(e) => handleFormFields(e.target.value,"qualification")} />
          <Text title="Caption1" value={currentFormData.caption1} onChange={(e) => handleFormFields(e.target.value,'caption1')} />
          <Text title="Caption2" value={currentFormData.caption2} onChange={(e) => handleFormFields(e.target.value,'caption2')} />
          <Text title="Caption3" value={currentFormData.caption3} onChange={(e) => handleFormFields(e.target.value,'caption3')} />
          <Text title="Cost" value={currentFormData.cost} onChange={(e) => handleFormFields(e.target.value,'cost')} />
          <span>Validity</span><br />
          <InputNumber title="Validity" placeholder={currentFormData.validity} min={0} max={10000} defaultValue={currentFormData.validity} onChange={onChange} />
          </div>
          <Select value={currentFormData.active  === true? 'Yes': "No"} onChange={(e) => handleFormFields(e, "true")}>
              <Option value={true}>Yes</Option>
              <Option value={false}>No</Option>
          </Select>
          <button className="submit-button" onClick={() => {
            UpdateQualication({ variables: {validity: validity,active: currentFormData.active,cost: currentFormData.cost,caption2:currentFormData.caption2,caption3:currentFormData.caption3,caption1:currentFormData.caption1,qcode: currentFormData.qcode,qualification:currentFormData.qualification,clientName:currentFormData.clientname,clientid:currentFormData.clientsid,manager:currentFormData.managersid1,id: currentFormData.qid} })
            closeForm()
            // UpdateNotificationWithIcon("success")
          }}>Update</button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
      {/* View */}
      <div className={isView ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Qualification
            </span>
            View Qualification
          </div>
        <div className="toggle-form-container">
          <div className="input-box-container">
            <div className="input-box-title">
            </div>
          </div>
          <div className="input-box-container">
          <Text title="Client" disabled value={currentFormData?.clientname} onChange={(e) => handleFormFields(e.target.value,'qcode')} />
          <Text title="Manager1" disabled value={currentFormData?.manager?.managername} onChange={(e) => handleFormFields(e.target.value,'qcode')} />
          <Text title="Qualification Name" disabled value={currentFormData.qualification} onChange={(e) => handleFormFields(e.target.value,"qualification")} />
          <Text title="Caption1" disabled value={currentFormData.caption1} onChange={(e) => handleFormFields(e.target.value,'caption1')} />
          <Text title="Caption2" disabled value={currentFormData.caption2} onChange={(e) => handleFormFields(e.target.value,'caption2')} />
          <Text title="Caption3" disabled value={currentFormData.caption3} onChange={(e) => handleFormFields(e.target.value,'caption3')} />
          <Text title="Cost" disabled value={currentFormData.cost} onChange={(e) => handleFormFields(e.target.value,'cost')} />
          <Text title="Validity" disabled value={currentFormData.validity} onChange={(e) => handleFormFields(e.target.value,'validity')} />
          <Text title="Validity" disabled value={currentFormData.active ? 'Yes': 'No'} onChange={(e) => handleFormFields(e.target.value,'validity')} />
          </div>
          <button className="submit-button" onClick={() => {
            closeForm()
            // UpdateNotificationWithIcon("success")
          }}>Print</button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default Qualifications